import React from "react";
import { FilterList } from "@mui/icons-material";
import { Fab, Grid, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

const filterButtonStyle = {
    padding: 11,
    marginRight: 10,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    borderTopLeftRadius: 30,
    borderBottomLeftRadius: 30,
};

const filterButtonWrapper = {
    position: "fixed",
    top: "90px",
    right: "-20px",
    zIndex: "100",
};

function FilterButton(props) {
    const { t } = useTranslation();

    return (
        <Grid item xs={2} style={filterButtonWrapper} id="fb_Grid">
            <Tooltip title={t("Filter")}>
                <Fab variant="extended" onClick={props.onClick()} style={filterButtonStyle} color="secondary">
                    <FilterList fontSize="large" align="right" id="fb_FilterList" />
                </Fab>
            </Tooltip>
        </Grid>
    );
}

export default FilterButton;
